export default "__VITE_ASSET__5ad0f4fe__"